import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchProcesses(customer_id) {
    return RequesterV1.get(
      `customer/quality_control/query_container/${customer_id}/list_processes`
    );
  },
};
